import { SearchableAccountV2Model } from '@logz-pkg/models';
import { AccountType } from '@logz-pkg/enums';
import { ICrudApiService } from '../../utilities/types';
import { CrudApiService } from '../../utilities/crud.api.service';

export class SearchableAccountsApiServiceForExplore implements ICrudApiService<SearchableAccountV2Model> {
  crudApiService = new CrudApiService({ modelDefinition: SearchableAccountV2Model });

  urls = {
    collection: 'searchable-accounts',
  };

  getAll = async (): Promise<SearchableAccountV2Model[]> => {
    const allAccounts = await this.crudApiService.getAll(this.urls.collection);

    return allAccounts;
  };

  getAccountsByType = async (accountType: AccountType | AccountType[]): Promise<SearchableAccountV2Model[]> => {
    const accountsByType = await this.crudApiService.getAll(this.urls.collection, undefined, { type: accountType });

    return accountsByType;
  };
}

export const searchableAccountsApiServiceForExplore = new SearchableAccountsApiServiceForExplore();
